<template>
  <section class="layout-section layout-grid">
    <!-- <article class="layout-grid__container">
      <router-link :to="{ name: 'projectUdy' }" tag="figure" class="layout-grid__figure">
        <img src="/images/udy-fpv/udy-thumbnail.png" alt="" class="layout-grid__image" />
      </router-link>

      <div class="layout-grid__content">
        <router-link :to="{ name: 'projectBloc '}" tag="h3" class="layout-grid__heading">Udy FPV</router-link>
        <h6 class="layout-grid__subheading">Branding — UI / UX Design</h6>
      </div>
    </article> -->

    <article class="layout-grid__container">
      <router-link :to="{ name: 'projectBloc' }" tag="figure" class="layout-grid__figure">
        <img src="/images/bloc-solutions/bloc-thumbnail.png" alt="" class="layout-grid__image" />
      </router-link>

      <div class="layout-grid__content">
        <router-link :to="{ name: 'projectBloc '}" tag="h3" class="layout-grid__heading">Bloc Solutions</router-link>
        <h6 class="layout-grid__subheading">Graphic Design — UI / UX Design — Web development</h6>
      </div>
    </article>

    <!-- <article class="layout-grid__container">
      <router-link :to="{ name: 'projectCag' }" tag="figure" class="layout-grid__figure">
        <img src="/images/cag/cag-thumbnail.png" alt="" class="layout-grid__image" />
      </router-link>

      <div class="layout-grid__content">
        <router-link :to="{ name: 'projectBloc '}" tag="h3" class="layout-grid__heading">Conception Alain Gagné</router-link>
        <h6 class="layout-grid__subheading">Branding — UI / UX Design — Web development</h6>
      </div>
    </article> -->

    <article id="project-karin" class="layout-grid__container">
      <router-link :to="{ name: 'projectKarin' }" tag="figure" class="layout-grid__figure">
        <img src="/images/karin-merinat/karin-thumbnail.png" alt="" class="layout-grid__image" />
      </router-link>

      <div class="layout-grid__content">
        <router-link :to="{ name: 'projectKarin' }" tag="h3" class="layout-grid__heading">Karin Mérinat, Yoga & Thaï Massage</router-link>
        <h6 class="layout-grid__subheading">Branding — UI / UX Design — Web development</h6>
      </div>
    </article>

    <article id="project-icons" class="layout-grid__container">
      <router-link :to="{ name: 'projectIcons' }" tag="figure" class="layout-grid__figure">
        <img src="/images/svg-icons/svg-icons-thumbnail.png" alt="" class="layout-grid__image" />
      </router-link>

      <div class="layout-grid__content">
        <router-link :to="{ name: 'projectIcons' }" tag="h3" class="layout-grid__heading">SVG Icons</router-link>
        <h6 class="layout-grid__subheading">Interface Design </h6>
      </div>
    </article>

    <article id="project-medioze" class="layout-grid__container">
      <router-link :to="{ name: 'projectMedioze' }" tag="figure" class="layout-grid__figure">
        <img src="/images/medioze/medioze-thumbnail.png" alt="" class="layout-grid__image" />
      </router-link>

      <div class="layout-grid__content">
        <router-link :to="{ name: 'projectMedioze' }" tag="h3" class="layout-grid__heading">Medioze, Web Agency</router-link>
        <h6 class="layout-grid__subheading">UI / UX Design — Web development</h6>
      </div>
    </article>

    <article class="layout-grid__container">
      <a href="https://www.behance.net/gallery/96374277/Free-blog-template-Simple-Food" target="_blank" rel="noopener" class="layout-grid__figure">
        <img src="/images/simple-food/thumbnail.png" alt="" class="layout-grid__image" />
      </a>

      <div class="layout-grid__content">
        <a href="https://www.behance.net/gallery/96374277/Free-blog-template-Simple-Food" target="_blank" rel="noopener"  class="layout-grid__heading">Simple Food, Free Blog Template</a>
        <h6 class="layout-grid__subheading">Interface Design </h6>
      </div>
    </article>

    <article id="project-uma" class="layout-grid__container">
      <router-link :to="{ name: 'projectUma' }" tag="figure" class="layout-grid__figure">
        <img src="/images/uma-yoga/uma-thumbnail.png" alt="" class="layout-grid__image" />
      </router-link>

      <div class="layout-grid__content">
        <router-link :to="{ name: 'projectUma' }" tag="h3" class="layout-grid__heading">Ūma Yoga, Studio</router-link>
        <h6 class="layout-grid__subheading">Branding — UI / UX Design — Web development</h6>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: 'HomeWeb'
}
</script>
